var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listPage" },
    [
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.TracksList.length > 0
        ? _c(
            "div",
            { staticStyle: { overflow: "auto" } },
            [
              _c("b-table", {
                staticClass: "table table-striped",
                staticStyle: { "margin-bottom": "0" },
                attrs: {
                  hover: "",
                  fields: _vm.fields,
                  items: _vm.TracksList,
                  selectable: _vm.TracksList.length > 0,
                  "empty-text": _vm.$t("common.no_result"),
                  role: "table",
                  "aria-label": _vm.$t("tracking.tracking_list_table"),
                  "sticky-header": "",
                  "thead-class": "text-center",
                  "tbody-class": "text-center",
                },
                on: { "row-clicked": _vm.seeTracksDetails },
                scopedSlots: _vm._u([
                  {
                    key: "cell(Date)",
                    fn: function (data) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))]),
                      ]
                    },
                  },
                  {
                    key: "cell(StatusFile)",
                    fn: function (data) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.translateStatusFile(data.value))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(FinalStatus)",
                    fn: function (data) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.translateFinalStatus(data.value))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(FileType)",
                    fn: function (data) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.translateFileType(data.value))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(bic_from)",
                    fn: function (data) {
                      return [_c("span", [_vm._v(_vm._s(data.value))])]
                    },
                  },
                ]),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "noResult" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("common.no_result")) + "\n    "
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }